// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__GQaqx","content":"LoadingAlert_content__36vsl"};